export default __webpack_public_path__ + "static/linkedin-02f01ab7f69797d51edcf1cc06ca8de9.png";